import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=0a91f882&scoped=true&"
import script from "./toolbar.vue?vue&type=script&lang=js&"
export * from "./toolbar.vue?vue&type=script&lang=js&"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=0a91f882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a91f882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a91f882')) {
      api.createRecord('0a91f882', component.options)
    } else {
      api.reload('0a91f882', component.options)
    }
    module.hot.accept("./toolbar.vue?vue&type=template&id=0a91f882&scoped=true&", function () {
      api.rerender('0a91f882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/toolbar/toolbar.vue"
export default component.exports